import {Actions, StateChanges} from './stateChanges'
import axios from 'axios/index'
import _ from 'lodash'
import defaultSettings from './defaultSettings'

const SERVER = process.env.SERVER_URL + '/classifier/'

const axiosInstance = axios.create({timeout: 60000})

// we always extract all types of features in order to fully populate the feature selection dialog
function getMapFeatureSetNameToFeatureSettings (state, useAll) {
  return _.transform(
    state.featureSettings,
    function (result, value, key) {
      if (useAll) {
        result[key] = value.settings
      } else if (value.active) {
        // if this feature set is active, send the settings along with a list of removed features
        result[key] = Object.assign({}, value.settings, { removedFeatures: state.removedFeatures[key] })
      }
    }
  )
}

function getClassesWithKeys (state) {
  return state.classes
    .filter(classData => classData.hasKeys())
}

function getClassesForServer (state) {
  return _.fromPairs(
    getClassesWithKeys(state)
      .map((classData, index) => ['class' + index, classData.keys])
  )
}

function haveMinimumClasses (state) {
  return state.classes && getClassesWithKeys(state).length > 1
}

function gtag () { window.dataLayer.push(arguments) }

export default {
  [Actions.RUN_EXTRACT_FEATURES]: function ({ commit, state }) {
    if (!haveMinimumClasses(state)) {
      console.log('Need at least two classes to run Extract Features.')
      return
    }
    commit(StateChanges.EXTRACT_FEATURES_RUNNING)
    axiosInstance.post(SERVER + 'statistics', {
      mapClassNameToTextKeys: getClassesForServer(state),
      'mapFeatureSetNameToFeatureSettings': getMapFeatureSetNameToFeatureSettings(state, true)
    })
      .then(function (response) {
        commit(StateChanges.SET_FEATURE_RESULTS, response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.EXTRACT_FEATURES_TIMED_OUT)
        } else {
          commit(StateChanges.EXTRACT_FEATURES_FAILED)
        }
      })
  },
  [Actions.RUN_CV]: function ({ commit, state }) {
    if (!haveMinimumClasses(state)) {
      console.log('Need at least two classes to run Crossvalidation.')
      return
    }
    commit(StateChanges.CROSSVALIDATION_RUNNING)
    setTimeout(() => {
      // BEGINNING OF GOOGLE ANALYTICS CODE
      console.log('REACHED BEGINNING OF "FEATURES" GOOGLE ANALYTICS CODE')
      Object.keys(state.removedFeatures).forEach(set => {
        state.removedFeatures[set].forEach(feature => {
          console.log('tagging single feature removal')
          gtag('event', 'feature removed', {
            'event_category': 'selection',
            'event_label': 'feature {' + feature + '} of Set {' + set + '} removed'
          })
        })
      })
      let defaultFeatureSettings = defaultSettings.getDefaultFeatureSettings()
      Object.keys(state.featureSettings).forEach(set => {
        let defaultActive = defaultFeatureSettings[set]['active']
        if (state.featureSettings[set]['active'] !== defaultActive) {
          console.log('tagging feature set (de)activation')
          let de = defaultActive ? 'de' : ''
          gtag('event', 'entire feature set ' + de + 'activated', {
            'event_category': 'selection',
            'event_label': 'feature set {' + set + '} ' + de + 'activated'
          })
        }
      })
      state.classes.forEach(aclass => {
        if (aclass['description'] !== null) {
          gtag('event', 'analysis', {
            'event_category': 'class',
            'event_label': 'class {' + aclass['description'] + '} cross-validated'
          })
        }
      })
      // END OF GOOGLE ANALYTICS CODE
    }, 1)
    axiosInstance.post(SERVER + 'crossvalidate', {
      mapClassNameToTextKeys: getClassesForServer(state),
      mapFeatureSetNameToFeatureSettings: getMapFeatureSetNameToFeatureSettings(state),
      testFraction: 0.2,
      maxSeconds: 8,
      maxExperiments: 100
    })
      .then(function (response) {
        commit(StateChanges.SET_CROSSVALIDATION_RESULTS, response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.CROSSVALIDATION_TIMED_OUT)
        } else {
          commit(StateChanges.CROSSVALIDATION_FAILED)
        }
      })
  },
  [Actions.RUN_CLASSIFICATION]: function ({ commit, state }) {
    if (!(state.testText && haveMinimumClasses(state))) {
      console.log('Cannot run classification. Need a test text and classes.')
      return
    }
    commit(StateChanges.CLASSIFY_RUNNING)
    // BEGINNING OF GOOGLE ANALYTICS CODE
    if (state.testText !== null) { // probably not necessary
      let classList = ''
      state.classes.forEach(aclass => {
        if (aclass['description'] !== null) {
          classList += '{' + aclass['description'] + '} and '
        }
      })
      if (classList.length > 0) { // probably not necessary
        classList = classList.slice(0, -5) // cut off last ' and '
      }
      gtag('event', 'analysis', {
        'event_category': 'text',
        'event_label': 'text {' + state.testText['description'] + '} analyzed against class ' + classList
      })
    }
    // END OF GOOGLE ANALYTICS CODE
    axiosInstance.post(SERVER + 'classify', {
      mapClassNameToTextKeys: Object.assign(
        { UNKNOWN: state.testText.keys },
        getClassesForServer(state)
      ),
      'mapFeatureSetNameToFeatureSettings': getMapFeatureSetNameToFeatureSettings(state),
      'mapFeatureSetNameToChunkSettings': state.chunking === 'SINGLE' ? { UNKNOWN: { chunkType: 'SINGLE' } } : {}
    })
      .then(function (response) {
        commit(StateChanges.SET_TEST_TEXT_RESULTS, response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.CLASSIFY_TIMED_OUT)
        } else {
          commit(StateChanges.CLASSIFY_FAILED)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/experimentActions.js